module.exports = __webpack_public_path__ + "img/dazhaohu.8ca33fa4.png";